// Preline 3.2.3's HSOverlay resize handler reads window.$hsOverlayCollection.length,
// but the collection is only created by HSOverlay.autoInit on window "load". A resize
// before load (scrollbar appearing, viewport changes) throws an uncaught TypeError.
// Must be imported before preline.
window.$hsOverlayCollection ??= []
